import React, { useEffect } from "react";
import { LiveChart } from "../../chart/liveChart";
import PropTypes from "prop-types";
import { Box, CircularProgress } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { getIsDashboardLiveTrendFetching, setIsDashboardLiveTrendFetching } from "../../../model/slice/customDashboardSlice";
import { fetchChartLinesAsync } from "../../../model/async/chartsAsync";
import { chartLinesData } from "../../../model/slice/chartsSlice";
import { fetchLiveTrendDataForDashboard, fetchLiveTrendLatestDataForDashboard } from "../../../model/async/customDashboardAsync";

export const LiveTrendWidget = (props) => {
  const { item, vessel } = props;
  const dispatch = useDispatch();
  const isFetching = useSelector(getIsDashboardLiveTrendFetching);
  const chartLines = useSelector(chartLinesData);

  useEffect(() => {
    if (!item) return;

    dispatch(fetchChartLinesAsync({ vesselId: vessel.id, chartId: item.id }));

    dispatch(
      fetchLiveTrendDataForDashboard({
        vesselId: vessel.id,
        channelNos: item.chNos,
        chartId: item.id,
      })
    );
    dispatch(setIsDashboardLiveTrendFetching(item.id));

    const latestLiveChartDataInterval = setInterval(() => {
      dispatch(
        fetchLiveTrendLatestDataForDashboard({
          vesselId: vessel.id,
          channelNos: item.chNos,
          chartId: item.id,
        })
      );
    }, 1000);
    return () => {
      clearInterval(latestLiveChartDataInterval);
    };
  }, [item]);

  return (
    <Box sx={{ height: "100%", padding: "8px 16px" }}>
      <h2 style={{ color: "white" }}>{item.chartName}</h2>
      {isFetching[item.id] ? (
        <CircularProgress />
      ) : (
        <LiveChart {...props} customLines={chartLines?.[item.id] ?? []} />
      )}
    </Box>
  );
};

LiveTrendWidget.propTypes = {
  item: PropTypes.object,
  vessel: PropTypes.object,
};
